import { ArrowUpRight } from "lucide-react";
import { Container } from "@/components/shared/PageHeader";
import { Reveal } from "@/components/shared/Reveal";
import { PhotoMosaic } from "@/components/shared/PhotoMosaic";

/** Dark gallery block with an asymmetric mosaic of every photo; any tile opens the viewer owned by the page. */
export const EventGallery = ({ images = [], captions = {}, display, alt = "", onOpen }) => {
  const n = images.length;
  if (n < 2) return null;
  return (
    <section id="bilete" className="grain scroll-mt-20 bg-ink py-16 text-paper sm:py-24" data-testid="event-gallery" aria-labelledby="gallery-title">
      <Container><Reveal>
        <div className="flex flex-wrap items-end justify-between gap-x-8 gap-y-4">
          <div>
            <p className="t-mono text-sol">Bilete</p>
            <h2 id="gallery-title" className="t-h2 mt-3 text-balance" data-testid="event-gallery-title">{n} bilete frå arrangementet</h2>
          </div>
          <button type="button" onClick={() => onOpen?.(0)} className="group inline-flex items-center gap-2 text-[15px] font-medium text-paper" data-testid="event-gallery-open-button">
            <span className="u-hover">Sjå alle i full storleik</span>
            <span className="flex h-7 w-7 items-center justify-center rounded-full bg-paper/15 transition-colors duration-300 group-hover:bg-sol group-hover:text-ink"><ArrowUpRight className="h-3.5 w-3.5" /></span>
          </button>
        </div>
        <PhotoMosaic images={images} captions={captions} display={display} alt={alt} tone="dark" onOpen={onOpen} className="mt-8 sm:mt-10" testId="event-gallery-grid" />
      </Reveal></Container>
    </section>
  );
};
